import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
  Input,
  ViewChild,
} from "@angular/core";
// import { GridOptions  } from "ag-grid-community";
// import { ClientSideRowModel } from "ag-grid-community";
// import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
// import { AgGridAngular } from '@ag-grid-community/angular';
// import { AgGridModule } from 'ag-grid-angular'; // Angular Data Grid Component
// import { ColDef } from 'ag-grid-community';
import { ServerService } from "src/app/services/server.service";
import { MatDatepicker } from "@angular/material/datepicker";
import * as saveAs from 'file-saver';
// import { MatSort } from '@angular/material/sort';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatPaginator,
} from "@angular/material";
import * as Highcharts from "highcharts";
import { SeriesSplineOptions, SeriesColumnOptions } from "highcharts";

import { AssignUserToCampaignComponent } from "../assign-user-to-campaign/assign-user-to-campaign.component";
import { ClipBoardService } from "src/app/services/clipboard.service";
import { CampaignLinksComponent } from "../campaign-links/campaign-links.component";
import { CampaignAttachmentsComponent } from "../campaign-attachments/campaign-attachments.component";
import { TaskStatusRemarkModalComponent } from "../task-status-remark-modal/task-status-remark-modal.component";
import { CreateCampaignTaskComponent } from "../create-campaign-task/create-campaign-task.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ClientCreateModalComponent } from "../../client-list/client-create-modal/client-create-modal.component";
import { ClientProjectCreateModalComponent } from "../../client-project/client-project-create-modal/client-project-create-modal.component";
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";
import { CampaignStatusComponent } from "../campaign-status/campaign-status.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { getDate } from "date-fns";
import { CreateCreativeJobComponent } from "../create-creative-job/create-creative-job.component";
import { AmountSpentListComponent } from "../../campaign-dir/amount-spent-list/amount-spent-list.component";
import { FeedbackListModalComponent } from "../../campaign-dir/feedback-list-modal/feedback-list-modal.component";
import { BudgetListComponent } from "../../campaign-dir/budget-list/budget-list.component";
import { LeadDeliveryListComponent } from "../../campaign-dir/lead-delivery-list/lead-delivery-list.component";
import { CreatePresalesJobComponent } from "../create-presales-job/create-presales-job.component";
import { RaiseEscalationComponent } from "../../campaign-dir/raise-escalation/raise-escalation.component";
import { CampaignJobLinksComponent } from "../campaign-job-links/campaign-job-links.component";
import { AssignUserToJobsComponent } from "../assign-user-to-jobs/assign-user-to-jobs.component";
import { CampaignJobAttachmentsComponent } from "../campaign-job-attachments/campaign-job-attachments.component";
import { PresalesDoneStatusComponent } from "../presales-done-status/presales-done-status.component";
import { CampaignProjectsComponent } from "../campaign-projects/campaign-projects.component";
import { EscalationStatusModalComponent } from "../../campaign-dir/escalation-status-modal/escalation-status-modal.component";
import { ViewTaskDetailsComponent } from "../view-task-details/view-task-details.component";
import { AssignClientToCampaignComponent } from "../assign-client-to-campaign/assign-client-to-campaign.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CreateMarketingJobComponent } from "../create-marketing-job/create-marketing-job.component";
import { AddAmountSpentComponent } from "../../campaign-dir/add-amount-spent/add-amount-spent.component";
import { AddLeadDeliveredComponent } from "../../campaign-dir/add-lead-delivered/add-lead-delivered.component";
import { AddBudgetComponent } from "../../campaign-dir/add-budget/add-budget.component";
import { AddFeedbackComponent } from "../../campaign-dir/add-feedback/add-feedback.component";
import { SaleCampaignProjectCreateModalComponent } from "../../campaign-dir/sale-campaign-project-create-modal/sale-campaign-project-create-modal.component";
import { VendorAssignModelComponent } from "../../client-list/vendor-assign-model/vendor-assign-model.component";
import { SaleCampaignClientCreateModalComponent } from "../../campaign-dir/sale-campaign-client-create-modal/sale-campaign-client-create-modal.component";
import { Title } from "@angular/platform-browser";
import { CreateCampaignReviewActionItemComponent } from "../create-campaign-review-action-item/create-campaign-review-action-item.component";
import { UpdateCampaignReviewActionItemComponent } from "../update-campaign-review-action-item/update-campaign-review-action-item.component";
import { CreateCampaignReviewComponent } from "../create-campaign-review/create-campaign-review.component";
import * as XLSX from 'xlsx';
import { CancelledStatusModalComponent } from "../cancelled-status-modal/cancelled-status-modal.component";
import { ListingPresalesProgressLogComponent } from "../listing-presales-progress-log/listing-presales-progress-log.component";
import { CreatePresalesProgressLogComponent } from "../create-presales-progress-log/create-presales-progress-log.component";
import { CampaignReChurnsProjectsComponent } from "../campaign-re-churns-projects/campaign-re-churns-projects.component";
import { CampaignMetaComponent } from "../campaign-meta/campaign-meta.component";
import { EscalationActionItemComponent } from "../../escalation/escalation-action-item/escalation-action-item.component";
import { EscalationFeedbackViewComponent } from "../../escalation/escalation-feedback-view/escalation-feedback-view.component";
import { EscalationResultComponent } from "../../escalation/escalation-result/escalation-result.component";
@Component({
  selector: "app-campaign-details", 
  templateUrl: "./campaign-details.component.html",
  styleUrls: ["./campaign-details.component.scss"],
  //encapsulation: ViewEncapsulation.None,
})
export class CampaignDetailsComponent implements OnInit {
  authToken = localStorage.getItem("token");
  // grid: GridOptions = {};
  // modules: any[] = [ClientSideRowModel];
  // rowData = [
  //   { make: "Tesla", model: "Model Y", price: 64950, electric: true },
  //   { make: "Ford", model: "F-Series", price: 33850, electric: false },
  //   { make: "Toyota", model: "Corolla", price: 29600, electric: false },
  // ];
  // rowDataCreativeJob:any = [];
  // colDefsCreativeJob:any = [];
  // // Column Definitions: Defines the columns to be displayed.
  // colDefs:any= [
  //   { field: "make",pinned: 'right' },
  //   { field: "model" },
  //   { field: "price" },
  //   { field: "electric" }
  // ];

  @ViewChild("campaignComment", { static: false }) campaignComment!: ElementRef;
  // @ViewChild(MatSort, { static: true }) sort: MatSort;

  campaignId: any;
  url: any = "";
  comments: any;
  showData = false;
  campaignIdAndUrl: any;
  detailExist = false;

  allCampaignDetails: any;
  duration_of_campaign: any;
  no_of_leads_of_campaign: any;
  drr: any;
  rrr: any;
  campaignProjects: any;
  strDel: any;

  assignUserToCampaignComponent: MatDialogRef<AssignUserToCampaignComponent>;
  assignUserToJobsComponent: MatDialogRef<AssignUserToJobsComponent>;
  campaignLinksComponent: MatDialogRef<CampaignLinksComponent>;
  campaignAttachmentsComponent: MatDialogRef<CampaignAttachmentsComponent>;
  taskStatusRemarkModalComponent: MatDialogRef<TaskStatusRemarkModalComponent>;
  createCampaignTaskComponent: MatDialogRef<CreateCampaignTaskComponent>;
  projectCreateModalComponent: MatDialogRef<ClientProjectCreateModalComponent>;
  campaignStatusComponent: MatDialogRef<CampaignStatusComponent>;
  createCreativeJobComponent: MatDialogRef<CreateCreativeJobComponent>;
  feedbackListModalComponent: MatDialogRef<FeedbackListModalComponent>;

  budgetListComponent: MatDialogRef<BudgetListComponent>;
  leadDeliveryListComponent: MatDialogRef<LeadDeliveryListComponent>;
  createPresalesJobComponent: MatDialogRef<CreatePresalesJobComponent>;
  campaignJobLinksComponent: MatDialogRef<CampaignJobLinksComponent>;
  campaignJobAttachmentsComponent: MatDialogRef<CampaignJobAttachmentsComponent>;
  presalesDoneStatusComponent: MatDialogRef<PresalesDoneStatusComponent>;
  campaignProjectsComponent: MatDialogRef<CampaignProjectsComponent>;
  viewTaskDetailsComponent: MatDialogRef<ViewTaskDetailsComponent>;
  assignClientToCampaignComponent: MatDialogRef<AssignClientToCampaignComponent>;

  createMarketingJobComponent: MatDialogRef<CreateMarketingJobComponent>;
  addAmountSpentComponent: MatDialogRef<AddAmountSpentComponent>;
  addLeadDeliveredComponent: MatDialogRef<AddLeadDeliveredComponent>;
  addFeedbackComponent: MatDialogRef<AddFeedbackComponent>;
  vendorAssignModelComponent: MatDialogRef<VendorAssignModelComponent>;
  listingPresalesProgressLogComponent:MatDialogRef<ListingPresalesProgressLogComponent>
  createPresalesProgressLogComponent:MatDialogRef<CreatePresalesProgressLogComponent>
  campaignReChurnsProjectsComponent:MatDialogRef<CampaignReChurnsProjectsComponent>
  campaignMetaComponent:MatDialogRef<CampaignMetaComponent>

  addBudgetComponent: MatDialogRef<AddBudgetComponent>;

  escalationActionItemComponent: MatDialogRef<EscalationActionItemComponent>;


  escalationFeedbackViewComponent:MatDialogRef<EscalationFeedbackViewComponent>;
  
  escalationResultComponent:MatDialogRef<EscalationResultComponent>;

 

  allTaskByCampaign: any;
  totalAttachments: any = 0;
  allTasksStatuses: any;
  totalLinks: any;

  modeOfDeliveryArr: any;
  strModeOfDeliveryArr: any;
  modAurum: boolean = false;
  modSheet: boolean = false;
  modCRM: boolean = false;
  modOther: boolean = false;

  typology: any;
  // console.log(modeOfDeliveryArr)
  // strtypology:any;
  // // console.log(strModeOfDeliveryArr)
  // hoverTypology:any;

  modeOfNotificationArr: any;
  strModeOfNotificationArr: any;
  notiEmail: boolean = false;
  notiSMS: boolean = false;
  // campaignTimeline: any;

  transformedData = [];
  changeDateTimeline = "";
  myDateRangePickerOptions = {
    dateFormat: "dd.mm.yyyy",
  };
  dateChangedVar = [];
  userInfo = JSON.parse(localStorage.getItem("userInfo"));
  clientCreateModalComponent: MatDialogRef<ClientCreateModalComponent>;
  amountSpentListComponent: MatDialogRef<AmountSpentListComponent>;
  raiseEscalationComponent: MatDialogRef<RaiseEscalationComponent>;
  escalationStatusModalComponent: MatDialogRef<EscalationStatusModalComponent>;
  saleCampaignProjectCreateModalComponent: MatDialogRef<SaleCampaignProjectCreateModalComponent>;
  saleCampaignClientCreateModalComponent: MatDialogRef<SaleCampaignClientCreateModalComponent>;
  createCampaignReviewActionItemComponent:MatDialogRef<CreateCampaignReviewActionItemComponent>
  updateCampaignReviewActionItemComponent:MatDialogRef<UpdateCampaignReviewActionItemComponent>;
  createCampaignReviewComponent:MatDialogRef<CreateCampaignReviewComponent>;
  cancelledStatusModalComponent:MatDialogRef<CancelledStatusModalComponent>

  showComponentLoader = true;
  financeTaskStatus = false;
  // private dialogRef: MatDialogRef<CampaignAttachmentsComponent>,
  allTaskStatus: any;
  anyMyTaskExist: any;
  initialCampaignStatusvar: any;
  visibleStatusIndex: number | null = null;
  campaignStats: any;
  statsPlatform: any = "";
  statsDateFilter: any = [];
  presales_and_creative_status_list: any;
  marketing_status_list: any;
  marketingJobs: any;
  escalation_status_list: any;
  dashboardItems = [
    {
      icon: "../../../../assets/images/campaign-icon/Time Elapsed.png",
      title: "Time Elapsed",
      value: "0",
      description: "",
      tooltipTemplate: `This metric indicates the duration (days) that has passed since the campaign was launched or made live. (Excluding the days when the campaign was on hold.)`,
    },
    {
      icon: "../../../../assets/images/campaign-icon/Leads Delivered.png",
      title: "Leads Delivered",
      value: 0,
      description: "",
      budget_description: "(Credit not assigned yet)",
      tooltipTemplate:
        "This metric represents total number of leads successfully delivered to the client, which may differ from the generated leads.",
    },
    {
      icon: "../../../../assets/images/campaign-icon/DRR.png",
      title: "DRR (Daily Run Rate)",
      value: "NA",
      description: "(NA)",
      tooltipTemplate:
        "The average number of leads delivered per day since the campaign started.(Excluding the days when campaign was on hold.)",
    },
    {
      icon: "../../../../assets/images/campaign-icon/RRR.png",
      title: "RRR (Required Run Rate)",
      value: 0,
      description: "",
      tooltipTemplate:
        "The average number of leads needed per day to meet the target."
    },
    {
      icon: "../../../../assets/images/campaign-icon/Total Budget.png",
      title: "Total Credit",
      value: 0,
      description: "",
      tooltipTemplate:
        "This metric shows the total credit allocated for the entire campaign."
    },
    {
      icon: "../../../../assets/images/campaign-icon/Total Amount Spent.png",
      title: "Total Credit Spent",
      value: 0,
      description: "",
      tooltipTemplate: "The total credit spent on the campaign so far"
    },
    {
      icon: "../../../../assets/images/campaign-icon/Current CPL.png",
      title: "Current CPL (Cost Per Lead)",
      value: "NA",
      description: "",
      tooltipTemplate:
      "The average cost per lead, calculated by dividing the total credit by the number of leads delivered."  
    },
    {
      icon: "../../../../assets/images/campaign-icon/Expected CPL.png",
      title: "Expected CPL (Cost Per Lead)",
      value: "NA",
      description: "",
      tooltipTemplate:
      "The average cost per lead, calculated by dividing the total credit assigned by the number of leads credit was assigned for."
    },
    {
      icon: "../../../../assets/images/campaign-icon/Qualification.png",
      title: "Qualification",
      value: "NA",
      description: "",
      tooltipTemplate:
        "The total number of leads accepted from client’s side out of delivered leads.",
    },
    {
      icon: "../../../../assets/images/campaign-icon/Qualification_OOT.png",
      title: "Qualification OOT",
      value: "NA",
      description: "",
      tooltipTemplate:
        "Number of leads verified by the client after 2 days(CPQL) and 4 days(CPL), considered out of TAT (Turnaround Time).",
    },
    {
      icon: "../../../../assets/images/campaign-icon/Generated Delta.png",
      title: "Leads Generated Delta",
      value: "NA",
      description: "",
      tooltipTemplate:
        "Number of leads generated outside system.The difference between total leads generated logged in the campaign and leads generated which exist in LMS(Project).",
    },
    {
      icon: "../../../../assets/images/campaign-icon/Delivered Delta.png",
      title: "Leads Delivered Delta",
      value: "NA",
      description: "",
      tooltipTemplate:
        "Number of leads delivered outside system.The difference between total leads delivered logged in the campaign and leads delivered to client which exist in LMS(Project).",
    },
  ];

  //stats Graphi variables
  campaignDateStats: any;
  campaignSpentStats: any;
  campaignDelivered: any;
  campaignGenerated: any;

  defaultStartDate: any;
  defaultEndDate: any;

  displayedColumnsCreativeJobid: any = ["creative_id"];
  displayedColumnsCreativeJob: any = [
    "created_at",
    "updated_at",
    "created_by",
    "creative_name",
    "job_type",
    "job_category",
    "platform",
    "campaign_type",
    "creative_type",
    "priority",
    
    "creative_size",
    "creative_description",
    "assets_count",
    "landing_page_link",
    "keyword_for_ad_copies",
    "end_at",
    "completed_at",
    "feedback",
  ];
  displayedColumnsCreativeJob2: any = [
    "assigned_user",
    "open_file_link",
    "asset",
    "creative-status",
  ];
  displayedColumnsPreSalesJob: any = [
    "presales_created_at",
    "presales_updated_at",
    "presales_created_by",
    "presales_team_lead",
    "calling_reason",
    "calling_type",
    "priority",
    "target_leads",
    "target_type",
    "source_leads",
    "results",
    "total_calls",
    "completed_at",
  ];
  displayedColumnsPresalesob2: any = [
    "assigned_user_presales_job",
    "presales_logs",
    "presales_pitch",
    "status",
  ];
  displayedColumnsPreSalesJobid: any = ["presales_id"];
  displayedColumnsEscalationJobid: any = ["escalation_id"];
  displayedColumnsEscalationJob: any = [
    "escalation_created_at",
    "escalation_updated_at",
    "escalation_created_by",
    "escalation_category",
    "issue_description",
    "escalation_priority",
    "impact",
    "deadline",
    "cc",
    "action_items",
    "results",
    "resolution_date_time",
    "resolution_feedback",
    
  ];
  displayedColumnsEscalationJob2: any = [
    "assigned_user_escalation",
    "supporting_files_links",
    "escalation_status",
  ];
  displayedColumnsMarketingJobid: any = ["marketing_id"];
  displayedColumnsMarketingJob: any = [
    "marketing_created_at",
    "marketing_updated_at",
    "marketing_job_type",
    "marketing_platform",
    "marketing_plaform_campaign_type",
    "marketing_campaign_type",
    "marketing_delivery_target",
    "marketing_budget_allocated",
    "marketing_amount_spent",
    "marketing_lead_generated",
    "marketing_lead_delivered",
    "marketing_instruction",
    "marketing_created_by",
    "marketing_feedback",
  ];
  displayedColumnsMarketingJob2: any = [
    "assigned_user_marketing",
    "marketing_files",
    "marketing_status",
  ];
  // dataSource:any;
  creativeJobs: any;
  preSalesJobs: any;
  escalationJobs: any;

  commentCategoryArr: any = [];

  taskData: any;
  combinedString: any = "";
  currentPage: number = 1;
  // loading: boolean = false;
  totalRecords: number = 100;
  campaignTimeline: any[] = [];
  excludeList = ["created_at", "campaign_id", "id", "created_by","campaign_stats_details","participants_id"];
  rReadonly = true;
  rForm: FormGroup;
  creative_status_list: any;
  // rowStyle:any;
  // getRowClass:any;

  review:any="we"
  participants_details:any;
  remainingParticipantsArray:any
  remainingParticipantsArrayEsc:any
  firstFiveName: string;
  reviewRemainingCount: number;
  review_list: any;
  // expandedIndex: number | null = null; 
  expandedSet: Set<number> = new Set();
  allActionItemsByCampaignId:any
  actionItemsByReviewId: { [key: number]: any[] } = {}; 
  leadReportProject:any;
  assigned_sales_user_temp:any;
  
  dealVlueInWord: any = '';
  effectiveDealVlueInWord: any = '';
  masterCreditInWord: any = '';
  visibleRows: number = 1;
  // visibleRowsMap: number[] = [];
  // visibleRowsMap: Set<number> = new Set();
  visibleRowsMap: number[] = [];
  mkPlatform:any
  // Add this to your component
expandedSections: { [key: number]: { issue: boolean; impact: boolean } } = {};

  constructor(
    private _serverService: ServerService,
    private dialog: MatDialog,
    private clipBoardService: ClipBoardService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private clipBoardMessageService: messageService,
    private el: ElementRef,
    private fb: FormBuilder,
    private titleService: Title,
  ) {
    this._activatedRoute.params.subscribe((params: any) => {
      this.campaignId = params.id;
      //console.log(params)
    });
    if(this.userInfo.role == 'SalesAdmin'){
      this.displayedColumnsMarketingJob = this.displayedColumnsMarketingJob.filter(item =>
        !["marketing_budget_allocated", "marketing_amount_spent"].includes(item)
      );
    }
    if (this.userInfo.role == "SalesAdmin") {
      const indexesToRemove = [4, 5, 6, 7];
      this.dashboardItems = this.dashboardItems.filter(
        (_, index) => !indexesToRemove.includes(index)
      );
    }
  }

  ngOnInit() {
    if(sessionStorage.getItem('report') || sessionStorage.getItem('campaign_details') ){
    sessionStorage.removeItem('report')
        sessionStorage.removeItem('campaign_details')
    }
    // this.dataSource = this.creativeJob;

    //   this.getRowClass = params => {
    //     if (params.node.rowIndex % 2 === 0) {
    //         return 'my-green-class';
    //     }
    // };
    // const namesArray = this.participants_details.map((ele: any) => ele.name);
    // const str = namesArray.join(',');
    // console.log(str);
    // this.getRemainingParticipants();
    this.getCampaignDetails();
    this.setEditditRvalue();
    this.getAllStatuses();
    this.commonData();
    this.timeLine();
    // this.getCampaignProject();
    // this.chartPlotting();
    if (this.userInfo.role != "SalesAdmin") {
      this.getCampaignStats();
    }

    // this.setCircle()
  }

  backToCampaign() {
    this._router.navigate(["/page/campaign-list"]);
  }
  commonData() {
    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details";

    this._serverService.getEscalationCategory(url, this.authToken).subscribe(
      (data) => {
        //console.log(data)
        this.mkPlatform = data.marketing_platform
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }
  descCreativeJobData() {
    if (Array.isArray(this.creativeJobs)) {
      // Create a new reference for the sorted array
      this.creativeJobs = [...this.creativeJobs].sort((a, b) => {
        const dateA = new Date(a.updated_at).getTime();
        const dateB = new Date(b.updated_at).getTime();
        return dateB - dateA;
      });
    } else {
      console.error('this.creativeJobs is not an array:', this.creativeJobs);
    }
  }
  transformedValue(){
 
    this.descCreativeJobData();
    this.changeDetectorRef.detectChanges();
    console.log(this.creativeJobs)
  }
  transformedValueByCreatedAt(){
    this.descCreativeJobDataCreatedAt();
  }
  descCreativeJobDataCreatedAt() {
    if (Array.isArray(this.creativeJobs)) {
      // Create a new reference for the sorted array
      this.creativeJobs = [...this.creativeJobs].sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA;
      });
    } else {
      console.error('this.creativeJobs is not an array:', this.creativeJobs);
    }
  }
  getCampaignDetails() {
    this.showComponentLoader = true;
    this._serverService
      .getCampaignDetailsByCampaignId(this.campaignId, this.authToken)
      .subscribe(
        (data) => {
          this.allCampaignDetails = data;
          this.assigned_sales_user_temp = this.allCampaignDetails.assigned_sales_user
          .reduce((acc, item) => (acc ? `${acc}, ${item.name}` : item.name), '');
          // console.log(this.assigned_sales_user_temp)
          this.titleService.setTitle('AutomateLeads - Campaings #' + this.allCampaignDetails.id + ' | ' + this.allCampaignDetails.client_name + ' - ' + this.allCampaignDetails.project_name);
          this.patchEditValue();
          // console.log(data.campaign_task.status == 'DONE')
          this.allTaskStatus = this.areAllTasksDone(data.campaign_task);
          // console.log(this.allTaskStatus)
          this.financeTaskStatus = this.isFinanceApproved(data.campaign_task);
          // console.log(this.financeTaskStatus)
          this.campaignStats = data.stats_data;
          console.log(data)
         this.review_list = data.campaign_reviews
         this.visibleRowsMap = this.review_list.map(() => 1); 
         
        //  console.log( this.review_list)
        //  this.firstFiveName = this.getFirstFiveNames()
        //  this.getRemainingParticipants();
        //  this.reviewRemainingCount = this.getRemainingCount()
        //  const namesArray = this.review_list.map((ele: any) => ele.name);
          // const str = namesArray.join(',');

          this.commentCategoryArr.push({
            id: 1,
            title: "Campaign",
            titleView: "Campaign",
            child: [
              {
                id: this.campaignId,
                title: "Campaign",
                parent: "Campaign",
                parentview: "Campaign",
              },
            ],
          });

          if (data.campaign_task.length) {
            for (let item of data.campaign_task) {
              item["title"] = item.task_type;
              item["parent"] = "CampaignTask";
              //item['parentview']='Campaign Job'
              item["parentview"] = "Task #" + item.id + " | " + item.task_type;
            }

            this.commentCategoryArr.push({
              id: 2,
              title: "CampaignTask",
              titleView: "Task",
              child: data.campaign_task,
            });
          }

          if (data.creative_jobs.length) {
            for (let item of data.creative_jobs) {
              item["title"] = item.job_type;
              item["parent"] = "CreativeJob";
              //item['parentview']='Creative Job'
              item["parentview"] =
                "Creative Job #" + item.id + " | " + item.job_type;
            }

            this.commentCategoryArr.push({
              id: 3,
              title: "CreativeJob",
              titleView: "Creative Job",
              child: data.creative_jobs,
            });
          }

          if (data.pre_sales_job.length) {
            for (let item of data.pre_sales_job) {
              item["title"] = item.calling_type;
              item["parent"] = "PreSalesJob";
              //item['parentview']='PreSales Job'
              item["parentview"] =
                "PreSales Job #" + item.id + " | " + item.calling_type;
            }

            this.commentCategoryArr.push({
              id: 4,
              title: "PreSalesJob",
              titleView: "PreSales Job",
              child: data.pre_sales_job,
            });
          }
          if (data.marketing_jobs.length) {
            for (let item of data.marketing_jobs) {
              item["title"] = item.job_type;
              item["parent"] = "MarketingJob";
              //item['parentview']='Marketing Job'
              item["parentview"] =
                "Marketing Job #" + item.id + " | " + item.job_type;
            }

            this.commentCategoryArr.push({
              id: 5,
              title: "MarketingJob",
              titleView: "Marketing Job",
              child: data.marketing_jobs,
            });
          }
          if (data.escalations.length) {
            for (let item of data.escalations) {
              item["title"] = item.escalation_category;
              item["parent"] = "Escalation";
              //item['parentview']='Escalation'
              item["parentview"] =
                "Escalation #" + item.id + " | " + item.escalation_category;
            }

            this.commentCategoryArr.push({
              id: 6,
              title: "Escalation",
              titleView: "Escalation",
              child: data.escalations,
            });
          }

          // console.log(this.commentCategoryArr)
          //  this.initialCampaignStatusvar = this.initialCampaignStatus(data.campaign_task)
          //  console.log(this.initialCampaignStatusvar)
          //  console.log(this.initialCampaignStatusvar)
          const statsMap = [
            { index: 0, key: "time_elapsed" },
            { index: 1, key: "leads_delivered" },
            { index: 2, key: "drr" },
            { index: 3, key: "rrr" },
            { index: 4, key: "total_budget", precision: 2 },
            { index: 5, key: "total_spent", precision: 2 },
            { index: 6, key: "current_cost_per_lead", precision: 2 },
            { index: 7, key: "expected_cost_per_lead", precision: 2 },
          ];

          // statsMap.forEach(stat => {
          //   const value = this.campaignStats[stat.key];
          //   this.dashboardItems[stat.index]["value"] = value != null
          //     ? (stat.precision != null ? value.toFixed(stat.precision) : value)
          //     : 0;
          // });

          // if (this.campaignStats["drr"] != null && this.campaignStats["rrr"] != null) {
          //   if (this.campaignStats["drr"].toFixed(2) < this.campaignStats["rrr"].toFixed(2)) {
          //     this.dashboardItems[2]["icon"] = '../../../../assets/images/campaign-icon/Drr-Red.png';
          //   }
          // }

          this.duration_of_campaign = data.duration;
          this.no_of_leads_of_campaign = data.no_of_leads;
          if (this.campaignStats != null) {
            if (this.drr != 0) {
              this.drr = this.campaignStats.drr;
            } else {
              this.drr = 0;
            }
            if (this.rrr != 0) {
              this.rrr = this.campaignStats.rrr;
            } else {
              this.rrr = 0;
            }
            // if(data.duration != null && this.campaignStats.time_elapsed != null){
            let remDay = data.duration - this.campaignStats.time_elapsed;
            // }

            this.dashboardItems[0]["description"] =
              "(" +
              this.campaignStats.time_elapsed +
              " out of " +
              data.duration +
              " days)";
            this.dashboardItems[0]["value"] =
              this.campaignStats.time_elapsed + " days";

            this.dashboardItems[1]["description"] =
              "(" +
              this.campaignStats.leads_delivered +
              " out of " +
              this.no_of_leads_of_campaign +
              " leads)";
            this.dashboardItems[1]["value"] =
              this.campaignStats.leads_delivered;

            this.dashboardItems[1]["budget_description"] =
              "(Credit assigned for " +
              this.campaignStats.leads_need_to_be_delivered +
              " leads)";

            // console.log(this.dashboardItems)
            this.dashboardItems[2]["description"] =
              "(" +
              this.campaignStats.leads_delivered +
              " leads in " +
              this.campaignStats.time_elapsed +
              " days)";
            // console.log(this.drr);
            // console.log(typeof this.drr)
            this.dashboardItems[2]["value"] = this.drr;

            this.dashboardItems[3]["description"] =
              "(" +
              (data.no_of_leads - this.campaignStats.leads_delivered) +
              " leads in " +
              remDay +
              " days)";
            this.dashboardItems[3]["value"] = this.rrr;
            if (this.userInfo.role != "SalesAdmin") {
              this.dashboardItems[4]["value"] = this.campaignStats.total_budget;

              this.dashboardItems[5]["value"] = this.campaignStats.total_spent;
              this.dashboardItems[6]["value"] = this.campaignStats
                .current_cost_per_lead
                ? this.campaignStats.current_cost_per_lead
                : "NA";
              this.dashboardItems[7]["value"] = this.campaignStats
                .expected_cost_per_lead
                ? this.campaignStats.expected_cost_per_lead
                : "NA";
            }

            //  console.log(this.campaignStats.lead_feedback_qualification.leads_qualified_percent)
            //  console.log(this.campaignStats.lead_feedback_qualification.leads_qualified_count)
            //  console.log( this.dashboardItems[8]["value"])
            // this.dashboardItems[8]["value"]=this.campaignStats.lead_feedback_qualification.leads_qualified_count;
            if (this.userInfo.role == "SalesAdmin") {
              if (
                this.campaignStats.lead_feedback_qualification
                  .leads_qualified_percent != null &&
                this.campaignStats.lead_feedback_qualification
                  .leads_qualified_count != null
              ) {
                this.dashboardItems[4]["value"] =
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_count +
                  " | " +
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_percent +
                  "%";
              }
              if (
                (this.campaignStats.lead_feedback_qualification.leads_qualified_out_of_tat_count !=
                  null &&
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_out_of_tat_percent != null)
              ) {
                this.dashboardItems[5]["value"] =
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_out_of_tat_count +
                  " | " +
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_out_of_tat_percent +
                  "%";
              }

              // this.dashboardItems[9]["value"]=this.campaignStats.current_cost_per_lead;
              // this.dashboardItems[10]["value"]=this.campaignStats.expected_cost_per_lead;
              // console.log(this.campaignStats.lms_lead_generated_count)
              if (
                this.campaignStats.leads_generated != null &&
                this.campaignStats.lms_lead_generated_count != null
              ) {
                this.dashboardItems[6]["value"] =
                  this.campaignStats.leads_generated -
                  this.campaignStats.lms_lead_generated_count;
              }
              if (
                this.campaignStats.leads_delivered != null &&
                this.campaignStats.lms_lead_delivered_count != null
              ) {
                this.dashboardItems[7]["value"] =
                  this.campaignStats.leads_delivered -
                  this.campaignStats.lms_lead_delivered_count;
              }
            } else {
              if (
                this.campaignStats.lead_feedback_qualification
                  .leads_qualified_percent != null &&
                this.campaignStats.lead_feedback_qualification
                  .leads_qualified_count != null
              ) {
                this.dashboardItems[8]["value"] =
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_count +
                  " | " +
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_percent +
                  "%";
              }
              if (
                this.campaignStats.lead_feedback_qualification
                  .leads_qualified_out_of_tat_count != null &&
                this.campaignStats.lead_feedback_qualification
                  .leads_qualified_out_of_tat_percent != null
              ) {
                this.dashboardItems[9]["value"] =
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_out_of_tat_count +
                  " | " +
                  this.campaignStats.lead_feedback_qualification
                    .leads_qualified_out_of_tat_percent +
                  "%";
              }

              // this.dashboardItems[9]["value"]=this.campaignStats.current_cost_per_lead;
              // this.dashboardItems[10]["value"]=this.campaignStats.expected_cost_per_lead;
              if (
                this.campaignStats.leads_generated != null &&
                this.campaignStats.lms_lead_generated_count != null
              ) {
                this.dashboardItems[10]["value"] =
                  this.campaignStats.leads_generated -
                  this.campaignStats.lms_lead_generated_count;
              }
              if (
                this.campaignStats.leads_delivered != null &&
                this.campaignStats.lms_lead_delivered_count != null
              ) {
                this.dashboardItems[11]["value"] =
                  this.campaignStats.leads_delivered -
                  this.campaignStats.lms_lead_delivered_count;
              }
            }

            // console.log(this.dashboardItems)
            // let temp = [];
            // temp = this.dashboardItems.filter((data)=>{
            //   return
            // })

            if (this.campaignStats["drr"] < this.campaignStats["rrr"]) {
              this.dashboardItems[2]["icon"] =
                "../../../../assets/images/campaign-icon/Drr-Red.png";
            }
            if (
              this.dashboardItems[6]["value"] > this.dashboardItems[7]["value"]
            ) {
              this.dashboardItems[6]["icon"] =
                "../../../../assets/images/campaign-icon/Current CPL-Red.png";
            }
            //console.log(this.allCampaignDetails)
            // if(this.userInfo.role == 'SalesAdmin'){
            //   this.dashboardItems = this.dashboardItems.filter((item, index) => index < 4 || index > 7 );
            // }
          }

          this.modeOfDeliveryArr = JSON.parse(data.mode_of_delivery);
          // console.log(this.modeOfDeliveryArr)
          this.strModeOfDeliveryArr = this.modeOfDeliveryArr.join(", ");
          // console.log(this.strModeOfDeliveryArr)
          this.strDel = this.strModeOfDeliveryArr
            .split(",")
            .map((mode) => mode.trim());

          //typology
          // console.log(data.typology)
          // console.log(typeof data.typology)
          // console.log(data.typology.lengths)
          if (data.topology != null) {
            this.typology = JSON.parse(data.topology);
            this.combinedString = this.typology
              .map(
                (item) => `${item.typologyConfiguration}, ${item.typologyPrice}`
              )
              .join(", ");
          }

          if (this.modeOfDeliveryArr != null) {
            this.modeOfDeliveryArr.includes("Automate Leads")
              ? (this.modAurum = true)
              : (this.modAurum = false);
            this.modeOfDeliveryArr.includes("CRM")
              ? (this.modCRM = true)
              : (this.modCRM = false);
            this.modeOfDeliveryArr.includes("Google Sheet")
              ? (this.modSheet = true)
              : (this.modSheet = false);
            this.modeOfDeliveryArr.includes("Other")
              ? (this.modOther = true)
              : (this.modOther = false);

            this.modeOfNotificationArr = JSON.parse(data.mode_of_notification);
            this.strModeOfNotificationArr =
              this.modeOfNotificationArr.join(", ");

            this.modeOfNotificationArr.includes("Email")
              ? (this.notiEmail = true)
              : (this.notiEmail = false);
            this.modeOfNotificationArr.includes("SMS")
              ? (this.notiSMS = true)
              : (this.notiSMS = false);
          }

          this.comments = data.comments;
          this.creativeJobs = data.creative_jobs;
          // this.creativeJobs.sort = this.sort;
          // console.log(this.creativeJobs.sort)
          // console.log(this.sort)
          this.marketingJobs = data.marketing_jobs;
          // this.rowDataCreativeJob = data.creative_jobs;
          // this.setupGrid();

          // console.log(this.rowDataCreativeJob[0])
          // this.colDefsCreativeJob = [
          //   {
          //     field: "id",pinned: 'left',width: 100
          //   },
          //   {
          //     field: "Job type"
          //   },
          //   {
          //     field: "Job Category"
          //   },
          //   {
          //     field: "Platform",pinned: 'left'
          //   },
          //   {
          //     field: "Campaign Type",pinned: 'left'
          //   },

          // ]
          // this.
          this.preSalesJobs = data.pre_sales_job;
          this.escalationJobs = data.escalations;
          // console.log(this.creativeJobs)
          // this.dataSource = data.creative_jobs;
          // console.log(this.dataSource)
          this.totalAttachments = this.getAttachmentLength(data);
          this.totalLinks = data.media_plan.length;
          this.allTaskByCampaign = data.campaign_task;
          this.anyMyTaskExist = this.myTaskExist(this.allTaskByCampaign);
          // if(this.allCampaignDetails.status == 'ON HOLD' || this.allCampaignDetails.status == 'LIVE' || this.allCampaignDetails.status == 'COMPLETED'){
          if (this.userInfo.role != "SalesAdmin") {
            this.getCampaignStats();
          }
          // this.loadMoreReview(data.campaign_reviews);
          // }
          this.showComponentLoader = false;
        },
        (error: any) => {
          // Handle error, specifically 404
          if (error.status === 404) {
            // Navigate to campaign list page when 404 occurs
            this._router.navigate(["/page/campaign-list"]);
          } else {
            // Handle other errors (optional)
            console.error("Error fetching campaign details:", error);
          }
        }
      );
  }

  assignUser(task: any) {
    // let campaignID = this.campaignId;
    // console.log(task.task_type)
    let body = task;

    body["campaign_id"] = this.campaignId;
    if (
      task.assigned_user_id == this.userInfo.id ||
      (task.task_type != "Finance Approval" &&
        this.userInfo.role != "FinanceAdmin")
    ) {
      this.assignUserToCampaignComponent = this.dialog.open(
        AssignUserToCampaignComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "500px",
          panelClass: "cdk-overlay-panel-right-side",
          data: body,
        }
      );
      this.assignUserToCampaignComponent.afterClosed().subscribe((result) => {
        if (result != undefined) {
          this.getCampaignDetails();
        }
      });
    }
  }

  statusChanged(task: any, new_status): any {
    task["new_status"] = new_status;
    this.taskStatusRemarkModalComponent = this.dialog.open(
      TaskStatusRemarkModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        data: task,
      }
    );
    this.taskStatusRemarkModalComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  //view task details

  viewTaskDetails(task: any) {
    // let campaignID = this.campaignId;
    // console.log(task.task_type)
    let body = task;

    body["campaign_id"] = this.campaignId;

    this.viewTaskDetailsComponent = this.dialog.open(ViewTaskDetailsComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      panelClass: "cdk-overlay-panel-right-side",
      data: body,
    });
  }

  //view task details ends here///
  // getAttachmentLength(data: any): Number {
  //   const properties = ["brochure", "creative_attachment", "media_plan_attachment"];
  //   return properties.reduce((total, prop) =>
  //      total + (data[prop].length || 0), 0);
  // }
  getAttachmentLength(data: any) {
    const properties = [
      "brochure",
      "creative_attachment",
      "media_plan_attachment",
    ];
    return properties.reduce(
      (total, prop) => total + (data[prop] ? data[prop].length : 0),
      0
    );
  }

  openAttachmentModal(data: any) {
    this.campaignAttachmentsComponent = this.dialog.open(
      CampaignAttachmentsComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        data: data,
        panelClass: "cdk-overlay-panel-right-side",
      }
    );
    this.campaignAttachmentsComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (
        result != undefined ||
        localStorage.getItem("deleteAttachment") == "true"
      ) {
        // console.log(typeof localStorage.getItem('deleteAttachment'))
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }

  openLinkModal(data: any) {
    // console.log(data['media_plan']);

    this.campaignLinksComponent = this.dialog.open(CampaignLinksComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      panelClass: "cdk-overlay-panel-right-side",
      data: data,
    });
    this.campaignLinksComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (
        result != undefined ||
        localStorage.getItem("link_deletion") == "true"
      ) {
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }

  getAllStatuses() {
    this._serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      // console.log(data)
      this.presales_and_creative_status_list = data.presales_status_list;
      // console.log(data)
      this.creative_status_list = data.creative_status_list;
      this.allTasksStatuses = data.campaign_task_status;
      this.marketing_status_list = data.marketing_status_list;
      this.escalation_status_list = data.escalation_status_list;
    });
  }

  createCampaignTask() {
    // if (this.allCampaignDetails.status != "LIVE") {
    // console.log(this.allCampaignDetails)
    this.createCampaignTaskComponent = this.dialog.open(
      CreateCampaignTaskComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        data: this.allCampaignDetails.id,
        panelClass: "cdk-overlay-panel-right-side",
      }
    );
    this.createCampaignTaskComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.getCampaignDetails();
        this.timeLine();
      }
    });
    // }
  }
  loadMore() {
    this.timeLine();
  }
  timeLine(reload?: any) {
    // debugger;

    this.transformedData = [];
    let record = 25;
    if (reload == "reload") {
      this.dateChangedVar = [];
      this.campaignTimeline = [];
      this.currentPage = 1;
      const filterBtnDiv1 = document.getElementById("date-filter");
      // if(datechanged.endDate.year == '0')

      // filterBtnDiv1.style.width = "70px";
      filterBtnDiv1.innerHTML = "Filter By Date";
    }

    if (this.dateChangedVar.length != 0) {
      this.url = "?created_at=" + JSON.stringify(this.dateChangedVar);
      this.campaignIdAndUrl = this.campaignId + this.url;
      this.campaignIdAndUrl =
        this.campaignIdAndUrl +
        "&page=" +
        this.currentPage +
        "&per_page=" +
        record;
      // this.currentPage = 1;
    } else {
      this.campaignIdAndUrl = this.campaignId;

      this.campaignIdAndUrl =
        this.campaignIdAndUrl +
        "?&page=" +
        this.currentPage +
        "&per_page=" +
        record;
    }

    // this.campaignIdAndUrl +='?page='+this.currentPage+'&per_page=25'
    this._serverService
      .getCampaignLog(this.campaignIdAndUrl, this.authToken)
      .subscribe((data) => {
        this.campaignTimeline = [...this.campaignTimeline, ...data.timeline];
        this.totalRecords = data.total_count;
        this.currentPage++;
        // console.log(this.campaignTimeline);
        // for (const [date, events] of Object.entries(this.campaignTimeline)) {
        //   this.transformedData.push({ date, events });
        // }
        this.changeDetectorRef.detectChanges();
      });
  }

  back() {
    this._router.navigate(["page/campaign-list"]);
  }

  dateChanged(datechanged: any) {
    const filterBtnDiv = document.getElementById("date-filter");
    // if(datechanged.endDate.year == '0')
    if (datechanged.endDate.year == "0") {
      // filterBtnDiv.style.width = "90px";
      filterBtnDiv.innerHTML = "Filter By Date";
      this.dateChangedVar = [];
      // this.campaignTimeline =[];
      // this.currentPage  = 1;
      this.currentPage = 1;
      this.timeLine();
    } else {
      // if (filterBtnDiv) {
      // filterBtnDiv.style.width = "156px";
      filterBtnDiv.innerHTML = `
    
   ${datechanged.beginDate.day}-${datechanged.beginDate.month}-${datechanged.beginDate.year} , ${datechanged.endDate.day}-${datechanged.endDate.month}-${datechanged.endDate.year}
    `;
      // }
      this.dateChangedVar = [];

      this.dateChangedVar.push(
        datechanged.beginDate.year +
          "-" +
          datechanged.beginDate.month +
          "-" +
          datechanged.beginDate.day
      );
      //  console.log(datechanged.endDate.year + '-' + datechanged.endDate.month + '-' + datechanged.endDate.day)
      this.dateChangedVar.push(
        datechanged.endDate.year +
          "-" +
          datechanged.endDate.month +
          "-" +
          datechanged.endDate.day
      );
      this.campaignTimeline = [];
      this.currentPage = 1;
      this.timeLine();
    }
  }

  openCreateModal() {
    this.saleCampaignClientCreateModalComponent = this.dialog.open(
      SaleCampaignClientCreateModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        panelClass: "cdk-overlay-panel-right-side",
        data: this.allCampaignDetails,
      }
    );
    this.saleCampaignClientCreateModalComponent
      .afterClosed()
      .subscribe((result) => {
        // console.log(result)
        if (result != undefined) {
          // this.getAllClients()
          this.openClientDialog(result);
          this.ngOnInit();
          // this.openClientDialog(result)
        }
      });
  }
  openClientDialog(element) {
    //console.log(element)
    this.vendorAssignModelComponent = this.dialog.open(
      VendorAssignModelComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        panelClass: "cdk-overlay-panel-right-side",
        data: element,
      }
    );
  }
  // createProject() {
  //   this.projectCreateModalComponent = this.dialog.open(
  //     ClientProjectCreateModalComponent,
  //     {
  //       hasBackdrop: true,
  //       disableClose: false,
  //       autoFocus: true,
  //       width: "50vw",
  //       panelClass: "cdk-overlay-panel-right-side",
  //       data:this.allCampaignDetails
  //     }
  //   );
  // }
  openProjectCreateModal() {
    this.saleCampaignProjectCreateModalComponent = this.dialog.open(
      SaleCampaignProjectCreateModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "50vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: this.allCampaignDetails,
      }
    );
    this.saleCampaignProjectCreateModalComponent
      .afterClosed()
      .subscribe((result) => {
        if (result != undefined) {
          this.showComponentLoader = true;
          // this.allSaleCampaign()
          this.ngOnInit();
        }
      });
  }
  areAllTasksDone(tasks: any[]): boolean {
    return tasks
      .filter((task) => task.created_by_user == "system")
      .every((task) => task.status.toUpperCase() === "DONE");
  }

  isFinanceApproved(tasks: any[]): boolean {
    for (const task of tasks) {
      if (task.task_type === "Finance Approval" && task.status != "Done") {
        return true;
      }
    }
    return false;
  }
  // initialCampaignStatus(tasks: any[]): boolean {
  //   return tasks.every(task => task.status === "TO DO");
  // }

  goLive(status: any) {
    let statusesandCampaignId = {
      campaignId: this.campaignId,
      status: status,
    };

    // status['campaignId'] = this.campaignId
    this.campaignStatusComponent = this.dialog.open(CampaignStatusComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "500px",
      data: statusesandCampaignId,
    });
    this.campaignStatusComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.getCampaignDetails();
        this.timeLine();
        // this.getAllClients()
        // this.openClientDialog(result)
      }
    });
    //   this.showComponentLoader = true;
    //   let body = {
    //     'status':status
    //   }
    //   let url = this.campaignId;
    //   // Send formData to server
    //   this._serverService.updateCampaignDetails(url,body, this.authToken).subscribe(response => {

    //     this.showComponentLoader = false;
    //     this.clipBoardMessageService.showMessgeInText(`Campaign Status Changed Succesfully`, "success-snackbar");
    //     this.getCampaignDetails();

    //     // this.dialogRef.close(response);
    //   }, error => {
    //     console.error('Upload failed', error);
    //     this.showComponentLoader = false;
    //   });
  }
  myTaskExist(tasks: any[]) {
    // return tasks.every(task => task.status === "DONE");
    return tasks.some((task) => task.assigned_user_id == this.userInfo.id);
  }
  statusContainer() {
    let container = document.getElementById("status-container-id");
    // console.log(container)
    // container.
    container.classList.toggle("active");
  }
  showStatusContainer(taskId: any): void {
    const container = document.getElementById(taskId);
    // let container = document.getElementById('status-container-' + taskId);
    // if (container) {
    container.classList.toggle("active");
    // } else {
    //   console.log("Container not found for task ID:", taskId);
    // }
  }

  toggleStatusPopup(task: any, index: number) {
    if (
      (task.assigned_user_id == this.userInfo.id &&
        this.userInfo.org_admin &&
        this.userInfo.member_type == "Vendor") ||
      task.assigned_user_id == this.userInfo.id ||
      this.userInfo.admin ||
      this.userInfo.role == "SalesAdmin"
    ) {
      // console.log(index)
      if (this.visibleStatusIndex === index) {
        this.visibleStatusIndex = null;
        // this.clicked = false;
      } else {
        this.visibleStatusIndex = index;
        // this.clicked = true;
      }
    }
  }
  chartPlotting() {
    Highcharts.chart("container", {
      chart: {
        zoomType: "xy",
        marginTop: 120,
        type: "spline" as "spline",
      },
      title: {
        text: "",
        align: "left",
      },
      xAxis: [
        {
          categories: this.campaignDateStats,
          crosshair: true,
          labels: {
            style: {
              color: "#5B5B5B",
              fontFamily: "Public Sans",
              fontSize: "12px",
              fontWeight: "400",
            },
          },
        },
      ],
      yAxis: [
        {
          labels: {
            format: "{value}",
            style: {
              color: "#BF9724",
              fontFamily: "Public Sans",
              fontWeight: "600",
              fontSize: "14px",
            },
          },
          title: {
            text: "Leads Generated",
            rotation: 270,
            style: {
              color: "#BF9724",
              fontFamily: "Public Sans",
              fontWeight: "600",
              fontSize: "14px",
            },
            x: 10,
          },
          allowDecimals: false,
          min: 0,
          opposite: true,
        },
        {
          gridLineWidth: 0,
          title: {
            text: "Total Credit Spent",
            style: {
              color: "#75CEB7",
              fontFamily: "Public Sans",
              fontWeight: "600",
              fontSize: "14px",
            },
          },
          labels: {
            format: "₹{value}",
            formatter: function () {
              return '₹' + Highcharts.numberFormat(this.value, 0, '.', ',');
            },
            style: {
              color: "#75CEB7",
              fontFamily: "Public Sans",
              fontWeight: "600",
              fontSize: "14px",
            },
          },
        },
        {
          gridLineWidth: 0,
          title: {
            text: "Leads Delivered",
            rotation: 270,
            style: {
              color: "#3E5AA1",
              fontFamily: "Public Sans",
              fontWeight: "600",
              fontSize: "14px",
            },
            x: 10,
          },
          labels: {
            format: "{value}",
            style: {
              color: "#3E5AA1",
              fontFamily: "Public Sans",
              fontWeight: "600",
              fontSize: "14px",
            },
          },
          allowDecimals: false,
          min: 0,
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
      },
      legend: {
        layout: "vertical",
        align: "left" as const,
        x: 60,
        verticalAlign: "top",
        y: 10,
        floating: true,

        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor ||
          "rgba(255,255,255,0.25)",
      },
      series: [
        {
          name: "Total Credit Spent",
          type: "column",
          yAxis: 1,
          data: this.campaignSpentStats,
          color: "#75CEB7"
          
        } as SeriesColumnOptions,
        {
          name: "Leads Delivered",
          type: "spline",
          yAxis: 2,
          data: this.campaignDelivered,
          marker: {
            enabled: false,
          },
          DashStyle: "shortdot",
          tooltip: {
            valueSuffix: " ",
          },
          color: "#3E5AA1",
        } as SeriesSplineOptions,
        {
          name: "Leads Generated",
          type: "spline",
          data: this.campaignGenerated,
          tooltip: {
            valueSuffix: "",
          },
          color: "#BF9724",
        } as SeriesSplineOptions,
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                floating: false,
                layout: "horizontal" as const,
                align: "center" as const,
                verticalAlign: "bottom" as const,
                x: 0,
                y: 0,
              },
              yAxis: [
                {
                  labels: {
                    align: "right",
                    x: 0,
                    y: -6,
                  },
                  showLastLabel: false,
                },
                {
                  labels: {
                    align: "right",
                    x: 0,
                    y: -6,
                  },
                  showLastLabel: false,
                },
                {
                  visible: false,
                },
              ],
            },
          },
        ],
      },
    });
  }
  getCampaignStats() {
    let body = {
      campaign_id: this.campaignId,
      date_range: ["2024-07-11", "2024-07-30"],
    };

    let date = new Date();
    // console.log(date.getDate()-30);
    let date_fix = new Date(new Date().setDate(date.getDate() - 15));

    body["date_range"][0] = this.formatDate(date_fix);

    body["date_range"][1] = this.formatDate(date);
    // console.log(this.formatDate(date_fix))
    this.defaultStartDate = this.formatDate(date_fix);
    this.defaultEndDate = this.formatDate(date);
    let tempDate = [];
    tempDate.push(this.defaultStartDate);
    tempDate.push(this.defaultEndDate);
    // console.log(tempDate)
    // console.log(this.formatDate(date))
    // this.dateChangedVar.push(body["date_range"][0]);
    // this.dateChangedVar.push(body["date_range"][1]);

    if (this.statsPlatform != "") {
      body["platform"] = this.statsPlatform;
    }
    // console.log(this.statsPlatform)
    if (this.dateChangedVar.length != 0) {
      body["date_range"] = this.dateChangedVar;
    } else {
      body["date_range"] = tempDate;
    }
    //     date_range
    // :
    // ["2024-08-01", "2024-08-08"]
    // console.log(this.dateChangedVar)
    // if(this.dateChangedVar != null ){
    //   // url =
    //   body["date_range"] = this.dateChangedVar;
    // }
    // body["date_range"] = ["2024-07-11", "2024-07-30"];
    let url = "campaign_module/campaign/campaign_lead_spent_stats";
    this._serverService
      .getCampaignStatsById(url, body, this.authToken)
      .subscribe((data) => {
        // console.log(data.data.recorded_date)
        this.campaignDateStats = data.data.recorded_date;
        this.campaignSpentStats = data.data.amount;
        this.campaignDelivered = data.data.lead_delivery;
        this.campaignGenerated = data.data.leads_generated;
        this.chartPlotting();

        // console.log(this.campaignGenerated)
      });
  }
  dateChangedStat(datechanged: any) {
    // console.log(datechanged)
    // debugger;
    const filterBtnDivStats = document.getElementById("filter-btn-stat-label");

    // if(datechanged.endDate.year == '0')
    if (datechanged.endDate.year == "0") {
      filterBtnDivStats.style.width = "133px";
      filterBtnDivStats.innerHTML =
        this.defaultStartDate + " , " + this.defaultEndDate;
      this.dateChangedVar = [];
      this.getCampaignStats();
      // this.timeLine();
    } else {
      // if (filterBtnDivStats) {
      filterBtnDivStats.style.width = "max-content";

      // }
      this.dateChangedVar = [];
      // console.log()
      // console.log(datechanged.begin.month)
      const padZero = (value: number) =>
        value < 10 ? `0${value}` : `${value}`;

      datechanged.beginDate.month = padZero(datechanged.beginDate.month);
      datechanged.beginDate.day = padZero(datechanged.beginDate.day);
      if (
        datechanged.beginDate.month != datechanged.endDate.month ||
        datechanged.beginDate.day != datechanged.endDate.day ||
        datechanged.beginDate.year != datechanged.endDate.year
      ) {
        datechanged.endDate.month = padZero(datechanged.endDate.month);
      }
      if (
        datechanged.beginDate.day != datechanged.endDate.day ||
        datechanged.beginDate.month != datechanged.endDate.month ||
        datechanged.beginDate.year != datechanged.endDate.year
      ) {
        datechanged.endDate.day = padZero(datechanged.endDate.day);
      }
      this.dateChangedVar.push(
        datechanged.beginDate.year +
          "-" +
          datechanged.beginDate.month +
          "-" +
          datechanged.beginDate.day
      );

      // if(datechanged.endDate.month<9){
      //   datechanged.endDate.month = "0" + datechanged.endDate.month;
      // }
      // if(datechanged.endDate.day<9){
      //   datechanged.endDate.day = "0" + datechanged.endDate.day;
      // }
      // }

      //  console.log(datechanged.endDate.year + '-' + datechanged.endDate.month + '-' + datechanged.endDate.day)
      this.dateChangedVar.push(
        datechanged.endDate.year +
          "-" +
          datechanged.endDate.month +
          "-" +
          datechanged.endDate.day
      );
      filterBtnDivStats.innerHTML = `
 
   
      ${datechanged.beginDate.day}-${datechanged.beginDate.month}-${datechanged.beginDate.year} , ${datechanged.endDate.day}-${datechanged.endDate.month}-${datechanged.endDate.year}
       `;
      // console.log(this.dateChangedVar)
      this.getCampaignStats();
      // this.timeLine();
    }
  }
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  backgroundPrioirityColor(priorityColor: any) {
    const priorityColors = {
      Low: "rgba(240, 222, 124, 0.2)",
      High: "rgba(241, 70, 33, 0.3)",
    };

    return priorityColors[priorityColor] || "rgba(255, 217, 142, 0.5)";
  }
  //createCreativeJobComponent
  createCreativeJob(editData?: any) {
   
    if (editData && editData.status.toUpperCase() === 'CANCELLED') {
     
      return; 
    }
    // console.log(data)
    // console.log(this.campaignId)
    let allData = {};
    allData["camapign_id"] = this.campaignId;
    allData["previous_value"] = editData;
    this.createCreativeJobComponent = this.dialog.open(
      CreateCreativeJobComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "cdk-overlay-panel-right-side",
        data: allData,
      }
    );
    this.createCreativeJobComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.getCampaignDetails();
        this.timeLine();
        // this.getAllClients()
        // this.openClientDialog(result)
      }
    });
  
  }

  createMarketingJob(editData?: any) {
    // console.log(editData)
    // console.log(this.campaignId)
    // if(editData.status.toUpperCase() != 'CANCELLED'){
      if (editData && editData.status.toUpperCase() === 'CANCELLED') {
     
        return; 
      }
    let allData = {};
    allData["campaign_id"] = this.campaignId;
    allData["previous_value"] = editData;
    this.createMarketingJobComponent = this.dialog.open(
      CreateMarketingJobComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1000px",
        panelClass: "cdk-overlay-panel-right-side",

        data: allData,
      }
    );
    this.createMarketingJobComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.getCampaignDetails();
        this.timeLine();
        // this.getAllClients()
        // this.openClientDialog(result)
      }
    });
  // }
  }

  createPreSalesJob(editData?: any) {
    if (editData && editData.status.toUpperCase() === 'CANCELLED') {
     
      return; 
    }
    // if(editData.status.toUpperCase() != 'CANCELLED'){
    let allData = {};
    allData["campaign_id"] = this.campaignId;
    allData["previous_value"] = editData;
    this.createPresalesJobComponent = this.dialog.open(
      CreatePresalesJobComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "cdk-overlay-panel-right-side",

        data: allData,
      }
    );
    this.createPresalesJobComponent.afterClosed().subscribe((result) => {
      // console.log(result)
      if (result != undefined) {
        this.getCampaignDetails();
        this.timeLine();
        // this.getAllClients()
        // this.openClientDialog(result)
      }
    });
  // }
  }
  openSpentListModal(project) {
    // console.log(this.campaignStats)

    if(this.userInfo.role == 'SalesAdmin'){
      return false
    }


    if (
      this.campaignStats != null &&
      this.campaignStats.latest_amount_spent_added != null
    ) {
      this.amountSpentListComponent = this.dialog.open(
        AmountSpentListComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "90vw",
          maxWidth: "90vw",
          panelClass: "cdk-overlay-panel-right-side",
          data: project,
        }
      );
    }
  }
  openFeedbackListModal(project) {
    if (
      this.campaignStats != null &&
      this.campaignStats.latest_feedback_analysis != null
    ) {
      this.feedbackListModalComponent = this.dialog.open(
        FeedbackListModalComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "90vw",
          maxWidth: "90vw",
          panelClass: "cdk-overlay-panel-right-side",
          data: project,
        }
      );
    }
  }

  openAddBudgetListModal(project) {

    if(this.userInfo.role == 'SalesAdmin'){
      return false
    }

    if (
      this.campaignStats != null &&
      this.campaignStats.latest_budget_added != null
    ) {
      this.budgetListComponent = this.dialog.open(BudgetListComponent, {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "90vw",
        maxWidth: "90vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      });
    }
  }

  openLeadDeliveryListModal(project) {

    if(this.userInfo.role == 'SalesAdmin'){
      return false
    }

    if (
      this.campaignStats != null &&
      this.campaignStats.latest_lead_delivey_added != null
    ) {
      this.leadDeliveryListComponent = this.dialog.open(
        LeadDeliveryListComponent,
        {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "90vw",
          maxWidth: "90vw",
          panelClass: "cdk-overlay-panel-right-side",
          data: project,
        }
      );
    }
  }

  openRaiseEscalationModal(project, editData?: any) {
    // if(project.status.toUpperCase() == 'CANCELLED'){
      if (editData && editData.status.toUpperCase() === 'CANCELLED') {
     
        return; 
      }
    project["previous_value"] = editData;
    this.raiseEscalationComponent = this.dialog.open(RaiseEscalationComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "1020px",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.raiseEscalationComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  // }
}
  assignUserJob(id: any) {
    // console.log(id)
  }
  openJobLinksModal(project, job_table_type: any) {
    if(project.status.toUpperCase() != 'CANCELLED'){
    project["job_table_type"] = job_table_type;
    this.campaignJobLinksComponent = this.dialog.open(
      CampaignJobLinksComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.campaignJobLinksComponent.afterClosed().subscribe((result) => {
      if (
        result != undefined ||
        localStorage.getItem("link_deletion_job") == "true"
      ) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  }
  assignUserToJobs(campaign: any, job_table_type: any) {
    if(campaign.status.toUpperCase() != 'CANCELLED'){
    campaign["job_table_type"] = job_table_type;
    // console.log(job_table_type)
    this.assignUserToJobsComponent = this.dialog.open(
      AssignUserToJobsComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        panelClass: "cdk-overlay-panel-right-side",
        data: campaign,
      }
    );
    this.assignUserToJobsComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.getCampaignDetails();
      }
    });
  }
  }
  openJobAttachmentModal(
    project,
    job_table_type: any,
    file_type?: any,
    status_changed?: any
  ) {
    //debugger;
    if(project.status.toUpperCase()  != 'CANCELLED'){
    project["status_changed"] = status_changed;
    project["file_type_job"] = job_table_type;
    project["job_table_type"] = file_type;
    this.campaignJobAttachmentsComponent = this.dialog.open(
      CampaignJobAttachmentsComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.campaignJobAttachmentsComponent.afterClosed().subscribe((result) => {
      if (
        result != undefined ||
        localStorage.getItem("Attachment_job") == "true"
      ) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  }
  jobStatusUpdate(element: any, job_type: any, status: any) {
    if(element.status.toUpperCase() != 'CANCELLED'){
    let url;
    // console.log(status)
    // console.log(status.target.value)
    if (job_type == "presales" && status == "Done") {
      this.preSalesDoneStatus(element);
    } else if (
      job_type == "escalation" &&
      (status == "In Progress" || status == "Resolved")
    ) {
      this.openEscalationUpdateModal(element, status);
    } else if (
      job_type == "escalation_feedback" ||
      job_type == "creative_feedback" ||
      job_type == "marketing_feedback"
    ) {
      this.openEscalationUpdateModal(element, status, job_type);
    } else if (job_type == "creative" && status == "Done") {
      this.openJobAttachmentModal(
        element,
        "creative",
        "creative_file",
        "status_changed"
      );
    } 
    else if(status.toUpperCase() == "CANCELLED"){
      this.cancelledStatusModal(element)
    }
    else {
      if (job_type == "presales") {
        url = "campaign_module/pre_sales_jobs/" + element.id;
      } else if (job_type == "escalation") {
        url = "campaign_module/escalation/" + element.id;
      } else if (job_type == "marketing") {
        url = "campaign_module/marketing_jobs/" + element.id;
      } else {
        url = "campaign_module/creative_jobs/" + element.id;
      }

      let formData = new FormData();
      formData.append("campaign_id", element.campaign_id);
      formData.append("status", status);

      // let url = this.data.id;
      this._serverService
        .updateEscalationJobDetails(url, formData, this.authToken)
        .subscribe((data) => {
          this.ngOnInit();
          // this.dialogRef.close(data);
          this.clipBoardService.showMessgeInText(
            "Status Changed Successfully",
            "success-snackbar"
          );
        });
    }
  }
  }
  openEscalationUpdateModal(project, status, type?: any) {
    project["new_status"] = status;
    // console.log(type);
    // console.log(status)
    project["job_type_feedback"] = type;
    this.escalationStatusModalComponent = this.dialog.open(
      EscalationStatusModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1020px",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.escalationStatusModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // console.log(result);
        //campaign_id,status,completed at
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  
  }
  preSalesDoneStatus(element) {
    // project['file_type_job'] = file_type;
    // project['job_table_type'] = job_table_type
    this.presalesDoneStatusComponent = this.dialog.open(
      PresalesDoneStatusComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: 'blue-snackbar',
        data: element,
      }
    );
    this.presalesDoneStatusComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  // getCampaignProject(){
  //   let url = 'get_campaign_projects?campaign_id='+this.campaignId;
  //   this._serverService.getCampaignProjectByCampaignId(url,this.authToken).subscribe((data: any) => {
  //     this.campaignProjects = data.data.projects;
  //     // console.log(data.data.projects)
  //   });
  // }
  openProjectListModal() {
    this.campaignProjectsComponent = this.dialog.open(
      CampaignProjectsComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1020px",
        panelClass: "cdk-overlay-panel-right-side",
        data: this.allCampaignDetails,
      }
    );
  }

  openRechurnProjectListModal() {
    this.campaignReChurnsProjectsComponent = this.dialog.open(
      CampaignReChurnsProjectsComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "1020px",
        panelClass: "cdk-overlay-panel-right-side",
        data: this.allCampaignDetails,
      }
    );
  }

  scrollToTarget(taskData: any) {
    if(taskData.status.toUpperCase() != 'CANCELLED'){
    this.taskData = taskData;
    this.campaignComment.nativeElement.scrollIntoView({ behavior: "smooth" });
    }
  }
  taskUserAccess(task: any) {
    if (this.userInfo.id == task.assigned_user_id || this.userInfo.admin) {
      return true;
    } else {
      return false;
    }
  }
  timeLineDetailExist(detail: any) {
    if (Object.keys(detail).length > 0) {
      return true;
    } else {
      return false;
    }
  }
  validDateParser(timelineDate: any): boolean {
    // Regular expression to match the ISO 8601 date format with timezone
    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}[+-]\d{2}:\d{2}$/;

    if (typeof timelineDate === "string" && regex.test(timelineDate)) {
      const date = new Date(timelineDate);
      return !isNaN(date.getTime());
    }
  }
  formatSnakeCase(snakeStr) {
    // Split the string into words based on underscores
    const words = snakeStr.split("_");

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the words back into a single string with spaces
    return capitalizedWords.join(" ");
  }
  filterTaskKeys(data: any) {
    const filteredData = Object.keys(data)
      .filter((key) => !this.excludeList.includes(key))
      .reduce((obj, key) => {
        obj[key] = data[key];
        return obj;
      }, {});
    return filteredData;
  }
  categoryMapper(key: string): string {
    const categoryMap: { [key: string]: string } = {
      CampaignTask: "Task",
      CreativeJob: "Creative Job",
      PreSalesJob: "Pre Sales Job",
      Escalation: "Escalation",
      Campaign: "Campaign",
      CampaignSpent: "Credit Spent",
      CampaignLeadDelivery: "Lead Delivery",
      LeadFeedbackAnalysis: "Feedback Analysis",
      CampaignBudget: "Credit",
      MarketingJob: "Marketing Job",
      CampaignReview :"Campaign Review",
      ActionItem:"Action Item",
      PreSalesProgressLog:"Pre Sales Progress Log"
    };

    return categoryMap[key] || key;
  }
  showId(category: any): boolean {
    const hiddenCategories = new Set([
      "CampaignSpent",
      "CampaignLeadDelivery",
      "LeadFeedbackAnalysis",
      "CampaignBudget",
    ]);

    return !hiddenCategories.has(category);
  }
  assignClientToCampaign() {
    // let campaignID = this.campaignId;
    // console.log(task.task_type)
    // let body = task;
    let body = this.allCampaignDetails;

    // body["campaign_id"] = this.campaignId;

    this.assignClientToCampaignComponent = this.dialog.open(
      AssignClientToCampaignComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "500px",
        panelClass: "cdk-overlay-panel-right-side",
        data: body,
      }
    );
    this.assignClientToCampaignComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.getCampaignDetails();
      }
    });
  }
  editRvalue() {
    this.rReadonly = false;
    // console.log(this.rReadonly);
    this.changeDetectorRef.detectChanges();
  }
  setEditditRvalue() {
    this.rForm = this.fb.group({
      r: ["", Validators.required],
      deal_value: ["", Validators.required],
      effective_deal_value: ["", Validators.required],
      master_budget: ["", Validators.required],
      agreement_date: ["", Validators.required],
    });
  }
  patchEditValue() {

    if(this.allCampaignDetails.deal_value){
      this.onInputChange(Number(this.allCampaignDetails.deal_value), 'dealValue')
    }

    if(this.allCampaignDetails.effective_deal_value){
      this.onInputChange(Number(this.allCampaignDetails.effective_deal_value), 'effectiveDealVlue')
    }

    if(this.allCampaignDetails.master_budget){
      this.onInputChange(Number(this.allCampaignDetails.master_budget), 'masterCredit')
    }

    this.rForm.patchValue({
      r: this.allCampaignDetails.r,
      deal_value: this.allCampaignDetails.deal_value,
      effective_deal_value: this.allCampaignDetails.effective_deal_value,
      master_budget: this.allCampaignDetails.master_budget,
      agreement_date: this.allCampaignDetails.agreement_date,
    });
    this.patchRequiredValidator();
  }
  patchRequiredValidator(): void {
    // Loop through each control in the form and add Validators.required
    Object.keys(this.rForm.controls).forEach((controlName) => {
      const control = this.rForm.get(controlName);
      if (control) {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity(); // Update the control to apply the validator
      }
    });
  }
  cancelEdit() {
    this.rReadonly = true;
    this.patchEditValue();
  }
  submitRvalue() {
    let body = {
      campaign_id: this.campaignId,

      r: this.rForm.value.r,
      deal_value: this.rForm.value.deal_value,
      effective_deal_value: this.rForm.value.effective_deal_value,
      master_budget: this.rForm.value.master_budget,
      agreement_date: this.rForm.value.agreement_date,
    };
    this._serverService
      .updateCampaignDetails(this.campaignId, body, this.authToken)
      .subscribe((data) => {
        this.rReadonly = true;
        this.rForm.reset();
        this.clipBoardMessageService.showMessgeInText(
          "R Values Updated Successfully",
          "success-snackbar"
        );
        this.ngOnInit();
        // this.dialogRef.close(data);
      });
  }
onInputChange(value: any, type:any): any {

    // const input = event.target as HTMLInputElement;
    // const filteredValue = input.value.replace(/[^0-9]/g, "");

    // if (input.value !== filteredValue) {
    //   input.value = filteredValue;
    // }

    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    let minValuesWithComma:any = value;

    if ((minValuesWithComma = minValuesWithComma.toString()).length > 9) return 'overflow';

    minValuesWithComma = ('000000000' + minValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!minValuesWithComma) return; var str = '';
    str += (minValuesWithComma[1] != 0) ? (a[Number(minValuesWithComma[1])] || b[minValuesWithComma[1][0]] + ' ' + a[minValuesWithComma[1][1]]) + 'crore ' : '';
    str += (minValuesWithComma[2] != 0) ? (a[Number(minValuesWithComma[2])] || b[minValuesWithComma[2][0]] + ' ' + a[minValuesWithComma[2][1]]) + 'lakh ' : '';
    str += (minValuesWithComma[3] != 0) ? (a[Number(minValuesWithComma[3])] || b[minValuesWithComma[3][0]] + ' ' + a[minValuesWithComma[3][1]]) + 'thousand ' : '';
    str += (minValuesWithComma[4] != 0) ? (a[Number(minValuesWithComma[4])] || b[minValuesWithComma[4][0]] + ' ' + a[minValuesWithComma[4][1]]) + 'hundred ' : '';
    str += (minValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(minValuesWithComma[5])] || b[minValuesWithComma[5][0]] + ' ' + a[minValuesWithComma[5][1]]) + 'only ' : '';

    if (type == 'dealValue') {
      this.dealVlueInWord = str;
    }

    if (type == 'effectiveDealVlue') {
      this.effectiveDealVlueInWord = str;
    }

    if (type == 'masterCredit') {
      this.masterCreditInWord = str;
    }

  }
  parseTimelineDetails(details: any): any {
    const parsedDetails: any = {};

    Object.keys(details).forEach((key) => {
      const rawValue = details[key];
      if (Array.isArray(rawValue) && rawValue.length === 2) {
        const [prevValue, newValue] = rawValue;

        // If the values are JSON strings, parse them
        try {
          const parsedPrevValue = JSON.parse(prevValue);
          const parsedNewValue = JSON.parse(newValue);

          // Check if the parsed values are objects or arrays and process accordingly
          parsedDetails[key] = [
            Array.isArray(parsedPrevValue) ||
            typeof parsedPrevValue === "object"
              ? JSON.stringify(parsedPrevValue)
              : prevValue,
            Array.isArray(parsedNewValue) || typeof parsedNewValue === "object"
              ? JSON.stringify(parsedNewValue)
              : newValue,
          ];
        } catch (e) {
          // If parsing fails, use the raw string values
          parsedDetails[key] = [prevValue, newValue];
        }
      } else {
        // Handle cases where value isn't a two-element array
        parsedDetails[key] = rawValue;
      }
    });

    return parsedDetails;
  }
  openAddAmountSpentModal(project) {
    this.addAmountSpentComponent = this.dialog.open(AddAmountSpentComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "85vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.addAmountSpentComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.ngOnInit();
      }
    });
  }
  openLeadDeliveryModal(project) {
    this.addLeadDeliveredComponent = this.dialog.open(
      AddLeadDeliveredComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "85vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: project,
      }
    );
    this.addLeadDeliveredComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.ngOnInit();
      }
    });
  }
  openAddBudgetModal(project) {
    this.addBudgetComponent = this.dialog.open(AddBudgetComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "85vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.addBudgetComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.ngOnInit();
      }
    });
  }
  openAddFeedbackModal(project) {
    this.addFeedbackComponent = this.dialog.open(AddFeedbackComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "100vw",
      maxWidth: "97vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: project,
    });
    this.addFeedbackComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        this.ngOnInit();
      }
    });
  }

  CommaInNumber(number: any) {
    if (typeof number != number) {
      return number;
    } else {
      let temp = number.toLocaleString("en-IN");
      return temp;
    }
  }
  downloadZipFile(element:any){
    if(element.status.toUpperCase() != 'CANCELLED'){
    this.showComponentLoader = true;
    // console.log(element)
    let url = "campaign_module/creative_jobs/download_creatives"
    let body = {
      "campaign_id": this.campaignId,
        "id": element.id
    }
    this._serverService.downloadZipFile(url, body)
    .subscribe((data) => {

      let today = new Date();
      let year = today.getFullYear();
      let month = (today.getMonth() + 1).toString().padStart(2, '0');
      let day = today.getDate().toString().padStart(2, '0');
      let formattedDate = `${year}-${month}-${day}`;
      const fileName = 'campaign_'+this.campaignId+ '_creatives_'+element.id + "_"+ formattedDate;
      this.showComponentLoader = false
      saveAs(new Blob([data.body], { type: 'application/zip' }), fileName+'.zip')
  });
}
  }
  skipColumn(timeline:any){
    if(
    (timeline.lms_object_type ==  'CampaignSpent' ||
    timeline.lms_object_type == 'CampaignLeadDelivery' ||
    timeline.lms_object_type == 'LeadFeedbackAnalysis' ||
    timeline.lms_object_type == 'PreSalesProgressLog' ||
    timeline.lms_object_type == 'CampaignBudget') ||
    timeline.action == "Purge"

  ){
    
      return true
    }
  else{
    return false;
  }
  }
  skipRecord(timeline:any){
    if(timeline.action == 'Created'){
      return true;
  }
  else{
    return false
  }
}

createCampaignReview(){
  this.createCampaignReviewComponent = this.dialog.open(
    CreateCampaignReviewComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "50vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: this.campaignId,
    }
  );
  this.createCampaignReviewComponent.afterClosed().subscribe((result) => {
    if (result != undefined) {
      this.showComponentLoader = true;
      this.ngOnInit();
      this.expandedSet.clear();
    }
  });
}

getFirstFiveNames(review:any): string {
 
  const firstThree = review.participants_user.slice(0, 5).map(participant => participant.name);
  return firstThree.join(', ');
}

getRemainingCount(review:any): number {
 
  if(review.participants_user.length > 5){
    return review.participants_user.length - 5;
  }
  return 0 ;
}

getRemainingParticipants(review:any): string {
  if (this.getRemainingCount(review) > 0) {
   
      const remainingParticipants = review.participants_user.slice(5).map(participant => participant.name);
     
      this.remainingParticipantsArray = remainingParticipants;
      // console.log(this.remainingParticipantsArray)
      return this.remainingParticipantsArray
  }
  return '';
}

//escalation
getFirstFiveNamesEsc(review:any): string {
 
  const firstThree = review.cc_users.slice(0, 5).map(participant => participant.name);
  return firstThree.join(', ');
}

getRemainingCountEsc(review:any): number {
 
  if(review.cc_users.length > 5){
    return review.cc_users.length - 5;
  }
  return 0 ;
}

getRemainingParticipantsEsc(review:any): string {
  if (this.getRemainingCountEsc(review) > 0) {
   
      const remainingParticipants = review.cc_users.slice(5).map(participant => participant.name);
     
      this.remainingParticipantsArrayEsc = remainingParticipants;
      // console.log(this.remainingParticipantsArray)
      return this.remainingParticipantsArray
  }
  return '';
}
//ends
expandReview(index: number,review): void {
  if(review.action_item_count != 0){
  if (this.expandedSet.has(index)) {
    this.expandedSet.delete(index); 
  } else {
    this.expandedSet.add(index); 

    this.getActionItems(review,index);
    // this.getActionItems(review,index)
  }
}
}

isExpanded(index: number): boolean {
  return this.expandedSet.has(index); 
}

addActionItems(item:any){
  this.createCampaignReviewActionItemComponent = this.dialog.open(
    CreateCampaignReviewActionItemComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "35vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: item,
    }
  );
  this.createCampaignReviewActionItemComponent.afterClosed().subscribe((result) => {
    if (result != undefined) {
      this.showComponentLoader = true;
      this.ngOnInit();
      this.expandedSet.clear();
    }
  });
}
updateActionItems(item:any,reviewInfo:any){
  item['review_id'] = reviewInfo.id
  this.updateCampaignReviewActionItemComponent = this.dialog.open(
    UpdateCampaignReviewActionItemComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "35vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: item,
    }
  );
  this.updateCampaignReviewActionItemComponent.afterClosed().subscribe((result) => {
    if (result != undefined) {
      this.showComponentLoader = true;
      this.expandedSet.clear();
      this.ngOnInit();
    }
  });
}
getActionItems(review:any,index:any){
  // console.log(review)
  if(review.action_item_count != 0)
  {
  // console.log(review)
  
  let url = 'campaign_module/campaign_reviews/'+review.id+'?campaign_id='+review.campaign_id
  this._serverService.getActionItemsByCampaignReviewId(url,this.authToken).subscribe((data)=>{
   
    this.actionItemsByReviewId[review.id] = data.action_items;
    
  })
}
}
fixToTwoDecimalPlace(number){
if(number){
return number.toFixed(2)
}
else{
return 0.00;
}
}
exportDetails(){
  this.showComponentLoader = true;
  let url = 'campaign_module/campaign/export_campaign'
  let body = {
    "campaign_id": this.campaignId
  }
  this._serverService.exportCampaignDetails(url,body,this.authToken).subscribe((data)=>{
  
   saveAs(new Blob([data.body], { type: 'application/xlsx' }), 'campaign_report'+'.xlsx')
   this.showComponentLoader = false;
  },
  (err: any) => {  
    console.error('Error exporting campaign:', err);
    this.showComponentLoader = false;
  }
)
}
downloadOpenFileZipFile(element:any){
  // console.log(element)
  if(element.open_files != null && element.status.toUpperCase() != 'CANCELLED'){
  this.showComponentLoader = true;
  // console.log(element)
  let url = "campaign_module/creative_jobs/download_openfiles"
  let body = {
    "campaign_id": this.campaignId,
      "id": element.id
  }
  this._serverService.downloadZipFile(url, body)
  .subscribe((data) => {

    let today = new Date();
    let year = today.getFullYear();
    let month = (today.getMonth() + 1).toString().padStart(2, '0');
    let day = today.getDate().toString().padStart(2, '0');
    let formattedDate = `${year}-${month}-${day}`;
    const fileName = 'campaign_'+this.campaignId+ '_open_files_'+element.id + "_"+ formattedDate;
    this.showComponentLoader = false
    saveAs(new Blob([data.body], { type: 'application/zip' }), fileName+'.zip')
});
}
}
cancelStatusBgColor(element:any){
  if(element.status.toUpperCase() == 'DONE' || element.status.toUpperCase() == 'RESOLVED')
  {
    return '#F1FFF1';
  }
  else if(element.status.toUpperCase() == 'CANCELLED'){
    return '#FFF7F6'
  }
  else{
return '#F6F6F6'
  }
   
  // console.log()
}
cancelStatusTextColor(element:any){
  if(element.status.toUpperCase() == 'DONE' || element.status.toUpperCase() == 'RESOLVED')
  {
    return '#006A00';
  }
  else if(element.status.toUpperCase() == 'CANCELLED'){
    return '#8B2A1D'
  }
  else{
return '#454545'
  }
   
  // console.log()
}
cancelStatusBorderColor(element:any){
  if(element.status.toUpperCase() == 'DONE' || element.status.toUpperCase() == 'RESOLVED')
  {
    return '0.5px solid #009F3F';
  }
  else if(element.status.toUpperCase() == 'CANCELLED'){
    return '0.5px solid #8B2A1D'
  }
  else{
return '0.5px solid #878787'
  }
   
  // console.log()
}
cancelledStatusModal(element:any){
  
    // project['file_type_job'] = file_type;
    // project['job_table_type'] = job_table_type
    this.cancelledStatusModalComponent = this.dialog.open(
      CancelledStatusModalComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "700px",
        panelClass: 'blue-snackbar',
        data: element,
      }
    );
    this.cancelledStatusModalComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  presalesLogsListing(element:any){
    this.listingPresalesProgressLogComponent = this.dialog.open(
      ListingPresalesProgressLogComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "55vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: element,
      }
    );
    this.listingPresalesProgressLogComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  CreatepresalesLog(element:any){
    this.createPresalesProgressLogComponent = this.dialog.open(
      CreatePresalesProgressLogComponent,
      {
        hasBackdrop: true,
        disableClose: false,
        autoFocus: true,
        width: "75vw",
        panelClass: "cdk-overlay-panel-right-side",
        data: element,
      }
    );
    this.createPresalesProgressLogComponent.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.showComponentLoader = true;
        // this.allSaleCampaign()
        this.getCampaignDetails();
        this.timeLine();
      }
    });
  }
  budgetToCredit(key:any){
    // console.log(key)
    switch(key){
      case 'Amount':return 'Credit Amount';
      case 'Budget Type':return 'Credit Type';
      default:return key;
    }
  //  return key == 'Amount'?'Credit Amount':key

  }
  spendToCredit(key:any){
    // console.log(key)
    switch(key){
      case 'Amount':return 'Credit Spent';
      // case 'Budget Type':return 'Credit Type';
      default:return key;
    }
  //  return key == 'Amount'?'Credit Amount':key

  }
  leadReport(){
    this.getCampaignProject()
   
  }
  getCampaignProject(){
    let url = 'get_campaign_projects?campaign_id='+this.campaignId;
    this._serverService.getCampaignProjectByCampaignId(url,this.authToken).subscribe((data: any) => {
      this.leadReportProject = data.data.projects;
      // console.log(this.allCampaignDetails)
      // this.leadReportProject.push({client_name:this.allCampaignDetails.client_name,project_name:this.allCampaignDetails.project_name,id:this.allCampaignDetails.id})
      sessionStorage.setItem('report',JSON.stringify(this.leadReportProject))
      let campaignDetail = {
        client_name:this.allCampaignDetails.client_name,project_name:this.allCampaignDetails.project_name,id:this.allCampaignDetails.id
      }
      sessionStorage.setItem('campaign_details',JSON.stringify(campaignDetail))
     
      // console.log(this.campaignProjects)
      // this.anyRechurnProject = this.anyChurnProject();
      this.showComponentLoader = false
      this._router.navigate(['page/lead-report/create'])
    });
   
  }
  getArray(item: any[]): string {
    return item.map(value => `<p>${value}</p>`).join('');
}
getDisplayValue(timeline: any, value: any[]): string {
  const selectedValue = this.skipColumn(timeline) && this.skipRecord(timeline)
    ? (this.validDateParser(value[1]) ? this.formatDate(value[1]) : this.getArray(value))
    : (this.validDateParser(value[0]) ? this.formatDate(value[0]) : this.getArray(value));

  return selectedValue;
}

metaCampaign(){
  let element = this.campaignId
  this.campaignMetaComponent = this.dialog.open(
    CampaignMetaComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "600px",
      panelClass: "cdk-overlay-panel-right-side",
      data: element,
    }
  );
  // this.createPresalesProgressLogComponent.afterClosed().subscribe((result) => {
  //   if (result != undefined) {
  //     this.showComponentLoader = true;
  //     // this.allSaleCampaign()
  //     this.getCampaignDetails();
  //     this.timeLine();
  //   }
  // });
}
getCCUser(items:any){
let temp = items.map((item)=>item.name).join(", ")
return temp
}

toggleRows(index: number, totalRows: number): void {
  this.visibleRowsMap[index] = this.visibleRowsMap[index] === 1 ? totalRows : 1;
}
getColorPriority(priority:any){
  let temp = priority.toLowerCase()
  switch(temp){
    case 'low':return 'rgba(240, 222, 124, 0.2)';
    case 'medium':return 'rgba(255, 217, 142, 0.5)';
    case 'high':return 'rgba(193, 35, 0, 0.33)';
    default:return 'black'
  }
}

viewEscActionItem(element:any){
  if(element.action_items){
  this.escalationActionItemComponent = this.dialog.open(
    EscalationActionItemComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "50vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: element,
    }
  );
}
}
viewEscResult(element:any){
  if(element.results){
  this.escalationResultComponent = this.dialog.open(
    EscalationResultComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "50vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: element,
    }
  );
}
}
viewEscFeedback(element:any){
  if(element.resolution_feedback){
  this.escalationFeedbackViewComponent = this.dialog.open(
    EscalationFeedbackViewComponent,
    {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,
      width: "50vw",
      panelClass: "cdk-overlay-panel-right-side",
      data: element,
    }
  );
}
}
// Toggle logic
toggleIssue(index: number): void {
  this.expandedSections[index] = this.expandedSections[index] || { issue: false, impact: false };
  this.expandedSections[index].issue = !this.expandedSections[index].issue;
}

toggleImpact(index: number): void {
  this.expandedSections[index] = this.expandedSections[index] || { issue: false, impact: false };
  this.expandedSections[index].impact = !this.expandedSections[index].impact;
}

}
